import React from 'react';

import { cx, css } from 'helpers';
import { BASE_COLOR as BC } from 'shared/constants/colors';


const blockquoteClass = css({
  color: '#888888',
  borderColor: BC.moonLightGray,
  fontSize: '18px',  // f4 (1.25rem) * 0.9

  // '& code': {
  //   fontSize: '14px',
  // }
});

export const Blockquote = props => (
  <blockquote
    className={cx(
      blockquoteClass,
      "mh0 ph3 bl bw1"
    )}
    {...props.attributes}
  >
    {props.children}
  </blockquote>
);



// WEBPACK FOOTER //
// ./src/components/slate/nodes/blockquote.js